<template>
  <div class="main-template">
    <!-- selectedCompanies:{{ selectedCompanies }} -->
    <v-row>
      <v-col>
        <v-tabs small v-model="activeTab" v-if="!$root.customerId" align-with-title show-arrows>
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab
            ><v-icon class="ma-2">mdi-table</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">{{ tabTitle }}</span></v-tab
          >
          <v-tab
            ><v-icon color="warning" class="ma-2">mdi-calendar</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">
              Calendar
            </span></v-tab
          >
        </v-tabs></v-col
      >
      <v-col><v-btn v-if="tabTitle != 'All Leads' && !activeTab" @click="mount()" color="info">Reset</v-btn></v-col>
      <v-col v-if="activeTab == 1">
        <div class="d-flex flex-wrap align-center">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Status Legend
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="d-flex flex-wrap align-center">
                  <div
                    v-for="(item, i) in leadStatus"
                    :key="i"
                    class="px-3 py-1 ma-1 white--text rounded-pill text-caption"
                    :style="{ backgroundColor: item.color }"
                  >
                    {{ item.status }}
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-col>
    </v-row>

    <d-table
      v-if="tableReady && !activeTab"
      :searchAfterCompleted="true"
      minSearchLength="6"
      tableName="shipments"
      :data_object="data_object"
      :getFreshData="getFreshData"
      :editData="tableData"
      :table_title="tableTitle"
      :linkClick="linkClick"
      :link="link"
      :breakpoint="0"
      :onDataReceived="onDataReceived"
      :getRowClass="getRowClass"
      :coloredFields="coloredFields"
      :getItemColor="getItemColor"
      :itemsPerPage="50"
      :filterCondition="filterCondition"
      :searchableColumns="searchableColumns"
      :numericFields="numericFields"
      :hasSearch="true"
      :hasAdvancedSearch="true"
      ref="dTable"
      :key="tableKey"
      :serverPagination="true"
      :remoteSearch="false"
      :showGroupBy="true"
      sortBy="shipment_id"
      :sortDesc="true"
      v-bind="vBind"
      :noDelete="noDelete"
      :toolBarControls="toolBarControls"
      :toolbarRight="true"
      :defaultTabCaption="defaultTabCaption"
      :columnTool="true"
      :defaultTabColor="defaultTabColor"
      :noTabs="noTabs"
      :noGroups="noGroups"
      :mobileViewTemplate="mobileViewTemplate"
      deleteId="sid"
      :remoteSearchFields="remoteSearchFields"
      :noCustomQry="noCustomQry"
    />
    <!-- <v-alert
      class="ma-4"
      dismissible
      timeout="3000"
      v-if="successMessage != '' && !noAlert"
      type="success"
    >
      {{ successMessage }}
    </v-alert> -->

    <v-data-calendar
      v-if="activeTab == 1"
      :calModel="calModel"
      :onDateChanged="onDateChanged"
      :eventTemplate="eventTemplate"
      :curDate="curDate"
      :data-object="data_object"
      :getQry="getQry"
      :getEventColor="getEventColor"
      :key="calKey"
      :eventClick="linkClick"
      :dayClick="dayClick"
      :calHeight="calendarHeight"
      :defaultType="defaultType"
      :eventType="eventType"
      :dateType="dateType"
      :onDataReceived="onDataReceived"
      :filter="calendarFilter"
      :summaryTemplate="summaryTemplate"
      ref="calendar"
      :categoryTemplate="categoryTemplate"
      :categoryName="categoryName"
      :categoryDays="categoryDays"
      :eventHeight="eventHeight"
      :showMore="false"
      :tableName="tableName"
      :noRefreshOnDayClick="true"
      :noVueChange="true"
    ></v-data-calendar>

    <v-snackbar v-if="successMessage != '' && !noAlert" v-model="successMessage" :timeout="3000" color="success">
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="successMessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-alert class="ma-4" timeout="3000" dismissible v-if="errorMessage != '' && errorMessage" type="error">
      {{ errorMessage }}
    </v-alert>
  </div>
</template>
<script>
import DTable from "../components/Table";
import axios from "axios";
import * as fun from "../plugins/common";

export default {
  components: {
    DTable: () => import("../components/Table.vue"),
    VDataCalendar: () => import("../components/DataCalendar.vue")
  },
  props: {
    searchInput: String
  },
  data() {
    return {
      tblClass: "",
      successMessage: "",
      errorMessage: "",
      tableKey: 0,
      tableReady: false,
      getFreshData: true,
      tableData: null,
      dataTable: null,
      tableTitle: "",
      showLegend: false,
      tabTitle: "All Leads",
      noCustomQry: false,
      dateField: "latest_date",
      link: {
        field: "shipment_id",
        name: "shipment"
      },
      latestDate: null,
      data_object: {
        object_name: "shipments",
        schema_name: "v_shipments",
        full_data_object_name: "shipments",

        // delete_object_name: "shipments",
        date_fields: ["latest_date"],

        qry_to_match: {},

        // mobileBreakpoint: 0,
        all_records: true,
        additional_data: [
          { obj_name: "service_type" },
          { obj_name: "lead_status" },
          { obj_name: "source" },
          { obj_name: "stage" },
          { obj_name: "company" },
          { obj_name: "ai_chat" },
          {
            obj_name: "employee",
            qry: {
              _id: this.$root.user_id
            }
          }
        ],
        additional_structure: [{ obj_name: "international_shipment" }],

        item_key: "shipment_id",
        table_title: "Shipments",
        hasSearch: true
      },
      coloredFields: ["service_type", "booked", "lead_status", "company_name"],
      serviceTypes: [],
      leadStatus: [],
      company: [],
      stages: [],
      filterTabs: [],
      originalRecords: [],
      searchableColumns: [],
      vBind: {},
      schema: null,
      selectRecords: false,
      plansSelected: [],
      toolBarControls: [],
      showSalesPersonList: 0,
      showCompaniesList: 0,
      selectedCompanies: [],
      showAssignButton: false,
      salesPerson: "",
      currentUser: "",
      noDelete: true,
      date: "",
      // defaultTabCaption: "All Future Shipments",
      defaultTabColor: "success",
      showSalesClicked: false,
      showCompaniesClicked: false,
      btnLabel: "Assign Sales Persons",
      btnLabelCompanies: "Assign Companies",
      // tableTitle: "Future Shipments",
      customerId: null,
      noTabs: false,
      noGroups: false,
      mobileViewTemplate: true,
      dateQry: null,
      employeeList: [],
      numericFields: ["shipment_id"],
      activeTab: 0,
      icon: {
        local: "mdi-truck",
        interstate: "mdi-highway",
        short_haul: "mdi-truck-outline",
        international: "mdi-ferry"
      },
      remoteSearchFields: [
        "first_name",
        "last_name",
        "full_name",
        "email",
        "customer_name",
        "mobile_phone",
        "shipment_id",
        "lead_id"
      ]
    };
  },
  mounted() {
    // this.updateShipmentDetails();

    this.mount();
  },

  methods: {
    mount() {
      var that = this;

      this.date = fun.formatDate(new Date(), true, null, true);
      this.latestDate = { $gte: this.date };
      this.getQry();
      this.$root.$on("customBtnClick", f => {
        if (f.btn == "assignSales") {
          that.showSales();
        }
        if (f.btn == "archive") {
          that.archive(f);
        }
        if (f.btn == "assignCompanies") {
          that.showCompanies();
        }
      });
      this.$root.$on("tableFilterChanged", t => {
        // console.log(t);
        if (t.tableName == "shipments") {
          if (t.currentFilter == 1 || t.currentFilter == 0) {
            // that.showAssignButton = true;
            // t.toolBarControls[0]["v-bind"].hidden = false;
          } else {
            // that.showAssignButton = false;
            // t.toolBarControls[0]["v-bind"].hidden = true;
          }
        }
      });
      //tableFilterChanged

      if (this.$root.customerId) {
        // this.customerId = this.$root.store.userData._id;
        // this.data_object.qry = { customer: this.customerId };
        this.data_object.qry = {};
        this.data_object.qry.customer_id = this.$root.customerId.$oid;
        this.data_object.id_fields = ["customer_id", "sid"];
        this.data_object.deleteId = "sid";

        this.noTabs = true;
        this.noGroups = true;
      } else {
        this.data_object.additional_delete_objects = [{ table_name: "shipment", id_name: "_id" }];
        // this.data_object.aggregate = {
        //   local_collection: "shipment",
        //   pipeline_name: "v_shipments",
        //   pipeline: [
        //     {
        //       $limit: 10,
        //     },
        //   ],
        // };
      }
      this.tableReady = true;
      if (this.tabTitle != "All Leads") {
        this.tableKey = !this.tableKey;
        this.tabTitle = "All Leads";
      }
      // this.$nextTick(() => {
      //   that.dataTable = that.$refs.dTable;
      // });
      this.$root.$on("tableSelectionChanged", t => {
        if (!t.selectDelete) {
          that.plansSelected = t.selected;
        }
      });
      this.toolBarControls = [];
      if (!this.$root.customerId) {
        this.toolBarControls = [
          {
            comp: "v-btn",
            id: "assignSales",
            default: false,
            "v-bind": {
              color: "info",
              text: true,

              // hidden: !this.showAssignButton,
              icon: "mdi-account-check",
              "input-value": "Assign Sales"
            }
          },
          {
            comp: "v-combo",
            id: "salesPersons",
            default: false,
            hidden: !this.showSalesPersonList,
            model: this.salesPerson,
            "v-bind": {
              objName: "v_sales_person",
              itemText: "full_name",
              itemValue: "_id",
              returnObject: true,
              onValueChange: this.assignSales,
              clearable: true
            }
          },
          {
            comp: "v-btn",
            id: "assignCompanies",
            default: false,
            "v-bind": {
              color: "info",
              text: true,

              hidden: this.company.length == 1,
              icon: "mdi-compare-horizontal",
              "input-value": "Assign Companies"
            }
          },
          {
            comp: "v-combo",
            id: "companies",
            default: false,
            hidden: !this.showCompaniesList,
            model: this.selectedCompanies,

            "v-bind": {
              objName: "company",
              itemText: "company_name",
              itemValue: "_id",
              onValueChange: this.assignCompanies,
              multiple: true,
              returnObject: true,
              clearable: true
            }
          }
        ];
      }
      this.toolBarControls.push({
        comp: "v-btn",
        id: "archive",
        "v-bind": {
          color: "warning",
          text: true,
          icon: "mdi-archive",
          "input-value": "View Past Shipments"
        }
      });
    },
    updateShipmentDetails() {
      axios
        .post(this.serverURL + "/update_shipment_details", null, {
          withCredentials: true
        })
        .then(r => {
          this.mount();
        });
    },
    eventTemplate: function(e, data, obj, unassigned) {
      var serviceDate = new Date(e.service_date);

      var start = new Date(serviceDate);
      // if (start.getDate() == 6) {
      //   console.log("yes!");
      // }

      var endTime = start.addHours(2);
      var status = this.leadStatus.find(r => {
        return r.status == e.lead_status;
      });
      var eventColor = "gray";
      if (status) {
        eventColor = status.color;
      }
      var r = e;

      var customerName = e.customer_name || e.first_name + " " + e.last_name;
      var ev = {
        _id: e._id,
        name: e.shipment_id + " " + customerName,
        start: serviceDate,
        shipment_id: e.shipment_id,
        icon: this.icon[e.move_type],

        status: e.lead_status || "New",
        color: eventColor,
        foreColor: this.$root.ajustColor(eventColor),
        more: e.more,
        end: endTime,
        timed: true
      };

      return ev;
    },
    getEventColor(e) {
      var status = this.leadStatus.find(r => {
        return r.status.toString().toLowerCase() == e.status.toString().toLowerCase();
      });
      var eventColor = "#000000";
      if (status) {
        eventColor = status.color;
      }
      return eventColor;
    },
    dayClick(d, dontChangeTab, tableData) {
      console.log(d);
      this.calModel = d;
      var dateEnd = new Date(d)
        .addDays(1)
        .toISOString()
        .split("T")[0];
      this.getQry(d, dateEnd);
      this.noCustomQry = true;
      this.tableReady = true;

      // this.getFreshData = false;
      // this.tableData = tableData.filter((r) => {
      //   return fun.formatDate(r[this.dateField]) == fun.formatDate(d);
      // });
      this.activeTab = 0;
      this.tabTitle = fun.formatDate(d);
      // this.toolBarControls.push({
      //   comp: "v-btn",
      //   id: "reset",
      //   default: false,
      //   "v-bind": {
      //     color: "info",
      //     text: true,

      //     // hidden: !this.showAssignButton,
      //     icon: "mdi-reload",
      //     "input-value": "Reset",
      //   },
      // });

      this.tableKey = !this.tableKey;
      this.dayClicked = true;
    },
    getQry(startDate, endDate) {
      var that = this;
      this.data_object.qry = this.$root.getQry();

      this.dateQry = {
        $or: [
          { latest_date: { $exists: false } },
          { latest_date: { $eq: null } },
          { latest_date: { $eq: "None" } },
          { latest_date: this.latestDate }
        ]
      };
      // this.data_object.qry_to_match = fun.clone(this.dateQry);
      // this.data_object.qry.$and.push(this.dateQry);
      this.currentUser = this.$root.store.userData;
      if (this.currentUser.company?.length && Array.isArray(this.currentUser.company)) {
        this.data_object.qry.$and.push({
          company_name: {
            $in: this.currentUser.company.map(r => {
              return r.company_name;
            })
          }
        });
      }

      var permittedActions = this.$root.store.permittedActions;
      // var filterJobs = false;
      // var noBooked = false;
      // var filterCompany = false;
      if (permittedActions) {
        permittedActions.forEach(a => {
          // if (a.filter_jobs && !this.$root.isAdmin) {
          //   filterJobs = true;
          //   // .sales_person_email = this.currentUser;
          // }
          if (a.bulk_delete) {
            this.noDelete = false;
          }
          if (a.shipment_filter) {
            a.shipment_filter.forEach(f => {
              Object.keys(f).forEach(k => {
                let values = f[k];

                if (typeof values === "string") {
                  values = values
                    .split(",")
                    .map(v => v.trim())
                    .filter(v => v); // remove empty strings
                }

                if (Array.isArray(values) && values.length) {
                  let q = {};
                  q[k] = { $in: values };
                  this.data_object.qry.$and.push(q);
                }
              });
            });
          }
          // if (a.hide_booked_jobs && !this.$root.isAdmin) {
          //   noBooked = true;
          // }
          // if (a.only_assigned_company) {
          //   filterCompany = true;
          // }
        });
      }
      // var noBookedQry = {
      //   $or: [
      //     { booked: 0 },
      //     {
      //       booked: { $exists: false },
      //     },
      //   ],
      // };

      // if (filterJobs) {
      //   // var booked = fun.clone(this.data_object.qry.booked);
      //   this.data_object.qry = {
      //     $and: [
      //       this.dateQry,
      //       {
      //         $or: [
      //           { "shipment_detail.sales_person._id": this.$root.user_id },
      //           { "agent.contact.email": this.currentUser },
      //         ],
      //       },
      //     ],
      //   };
      //   if (noBooked) {
      //     this.data_object.qry.$and.push(noBookedQry);
      //   }
      // } else {
      //   if (noBooked) {
      //     this.data_object.qry = {
      //       $and: [this.dateQry, noBookedQry],
      //     };
      //   } else {
      //     this.data_object.qry = this.dateQry;
      //   }
      // }
      if (this.$root.filteredCompanies()) {
        if (!this.data_object.id_fields) {
          this.data_object.id_fields = [];
        }
        this.data_object.id_fields.push("_id");
        // var list_of_company_ids = this.$root.store.userData.company.map(
        //   (c) => c._id["$oid"]
        // );
        // var filterCompanyQry = {
        //   $expr: {
        //     $in: [
        //       { $toString: "$shipment_detail.company._id" },
        //       this.$root.filteredCompanies(),
        //     ],
        //   },
        //   // "shipment_detail.company._id": {
        //   //   $in: this.$root.filteredCompanies(),
        //   // },
        // };
        // if (!this.data_object.qry.$and) {
        //   this.data_object.qry.$and = [];
        // }
        // this.data_object.qry.$and.push(filterCompanyQry);
      }
      if (!this.data_object.qry.$and?.length && !startDate && !endDate) {
        this.data_object.qry = {};
      }
      if (startDate && endDate) {
        this.dateQry = {};
        this.dateQry[this.dateField] = {
          $gte: fun.formatDate(new Date(startDate), true),
          $lte: fun.formatDate(endDate, true)
        };

        this.data_object.qry.$and.push(this.dateQry);
      }
      return this.data_object;
    },
    linkClick: function(item) {
      if (!item.customer_name) {
        item.customer_name = item.first_name + " " + item.last_name;
      }
      if (item.event) {
        item.shipment_id = item.event.shipment_id;
        item.customer_name = item.event.name.replace(item.shipment_id, "").trim();
      }
      item.icon = this.icon[item.move_type];
      this.$root.addResentTab(item);
    },
    showCompanies(completed) {
      if (!this.showCompaniesClicked) {
        this.$refs.dTable.selected = [];
        this.$refs.dTable.select = !this.$refs.dTable.select;
        this.selectRecords = this.$refs.dTable.select && !this.$refs.dTable.selectDelete;

        this.btnLabelCompanies =
          this.selectRecords && this.btnLabelCompanies == "Assign Companies"
            ? "Please select records to assign"
            : "Assign Companies";
        this.toolBarControls[2]["v-bind"]["input-value"] = this.btnLabelCompanies;
      } else {
        var cmb = this.toolBarControls[3];
        if (!this.selectedCompanies.length) {
          return;
        }
        this.$root.$confirm
          .open("Multiply", "Multiply Leads for selected companies?", {
            color: "green"
          })
          .then(confirm => {
            if (confirm) {
              var ids = [];
              this.plansSelected.forEach(r => {
                ids.push(r.sid);
              });

              this.multiplyLeads(ids);
            }
          });
      }
      if (!completed) {
        this.showCompaniesClicked = true;
      }

      this.toolBarControls[3].hidden = !this.showCompaniesList;
    },
    showSales() {
      // console.log("assign Sales");
      this.showSalesClicked = true;
      this.$refs.dTable.selected = [];
      this.$refs.dTable.select = !this.$refs.dTable.select;
      this.selectRecords = this.$refs.dTable.select && !this.$refs.dTable.selectDelete;

      this.btnLabel =
        this.selectRecords && this.btnLabel == "Assign Sales Persons"
          ? "Please select records to assign"
          : "Assign Sales Persons";
      this.toolBarControls[0]["v-bind"]["input-value"] = this.btnLabel;
      this.toolBarControls[1].hidden = !this.showSalesPersonList;
      //plansSelected
    },
    archive() {
      var btn = null;
      // this.data_object.qry = {};
      if (this.$root.customerId) {
        btn = this.toolBarControls[0]["v-bind"];
        // if (this.$root.customerId) {
        this.data_object.qry.customer_id = this.$root.customerId.$oid;
        this.data_object.id_fields = ["customer_id"];
        // }
      } else {
        btn = this.toolBarControls[2]["v-bind"];
        var spBtn = this.toolBarControls[0]["v-bind"];
        var sp = this.toolBarControls[1]["v-bind"];
      }
      var caption = btn["input-value"];
      var hidden = false;
      // var shipmentBtn =
      //   this.toolBarControls.length > 1
      //     ? this.toolBarControls[4]["v-bind"]
      //     : this.toolBarControls[0]["v-bind"];
      // var shipmentCaption = shipmentBtn["input-value"];

      // if (shipmentCaption == "View Past Shipments") {
      //   shipmentCaption = "View Future Shipments";
      //   shipmentBtn.icon = "mdi-truck-delivery";
      //   shipmentBtn.color = "success";
      //   this.latestDate = { $lt: this.date };

      //   this.defaultTabCaption = "All Past Shipments";
      //   this.tableTitle = "Past Shipments";
      //   this.defaultTabColor = "warning";
      //   hidden = true;
      // } else {
      //   // this.tableTitle = "Future Shipments";
      //   shipmentCaption = "View Past Shipments";
      //   shipmentBtn.icon = "mdi-archive";
      //   shipmentBtn.color = "warning";
      //   this.latestDate = { $gte: this.date };
      //   // this.data_object.qry = {
      //   //   latest_date: { $gte: this.date },
      //   // };
      //   this.defaultTabCaption = "All Future Shipments";
      //   // this.tableTitle = "Future Shipments";
      //   this.defaultTabColor = "success";
      //   hidden = false;
      // }
      if (spBtn) {
        spBtn["hidden"] = hidden;
      }

      this.getQry();
      // shipmentBtn["input-value"] = shipmentCaption;
      this.tableKey = !this.tableKey;
    },
    assignCompanies(cmb) {
      this.selectedCompanies = cmb.value;
    },
    assignSales(cmb) {
      // console.log(cmb.value);
      if (this.showSalesPersonList) {
        if (cmb.value) {
          var employee = this.employeeList[0];

          // var sp =
          //   employee.contact.first_name + " " + employee.contact.last_name;
          var confirmLabel = cmb.value
            ? "Confirm assigning " + this.plansSelected.length + " record(s) to " + cmb.value.full_name + "?"
            : "Confirm removing sales person from " + this.plansSelected.length + " record(s)?";
          this.$root.$confirm
            .open("Delete", confirmLabel, {
              color: "red"
            })
            .then(confirm => {
              if (confirm) {
                var ids = [];
                this.plansSelected.forEach(r => {
                  ids.push(r.sid);
                });
                var spObj = cmb.value;
                this.updateSalesPersons(spObj, ids);
              }
            });
        }
      }
    },
    updateSalesPersons(v, ids) {
      var that = this;
      var metadata = {
        object_name: "shipment",
        addititional_object_names: ["shipments"],
        ids: ids
      };
      var data = {
        metadata: metadata,
        updated_model: { sales_person: v.full_name, "shipment_detail.sales_person": v || {} },
        model: {
          "shipment_detail.sales_person": v || {},
          stage: "assigned_leads"
        }
      };

      axios
        .post(this.serverURL + "/update_many", data, {
          withCredentials: true
        })
        .then(r => {
          // console.log(r);
          // this.$refs.dTable.select = false;
          this.$refs.dTable.selected = [];
          // this.$refs.dTable.currentFilter = 1;
          this.$refs.dTable.refresh();

          this.showSales();
          this.successMessage = r.data + ": " + ids.length + " shipments assigned";
        });
    },

    multiplyLeads(ids) {
      var that = this;
      var data = {
        company_array: this.selectedCompanies,
        id_array: ids
      };

      axios
        .post(this.serverURL + "/multiply_leads", data, {
          withCredentials: true
        })
        .then(r => {
          this.$refs.dTable.selected = [];

          this.$refs.dTable.refresh();
          this.showCompaniesClicked = false;
          this.showCompanies(true);
          var totalShipments = ids.length * this.selectedCompanies.length;
          this.successMessage = totalShipments + " new shipments created";
        });
    },
    getItemColor(value, field) {
      var color = "black";
      switch (field) {
        case "service_type":
          this.serviceTypes.forEach(s => {
            if (s.service_type == value) {
              if (s.color && s.color.replace) {
                // if (!isItem) {
                //   color = s.color.replace("#", "");
                // } else {
                color = s.color;
                // }
              } else {
                color = "";
              }
            }
          });
          // if (!isItem) {
          //   return "color-" + color;
          // } else {
          return color;
        // }

        case "lead_status":
          this.leadStatus.forEach(s => {
            if (s.status == value) {
              if (s.color && s.color.replace) {
                // if (!isItem) {
                //   color = s.color.replace("#", "");
                // } else {
                color = s.color;
                // }
              } else {
                color = "black";
              }
            }
          });
          if (value.includes("used AI")) {
            return "#c90df2";
          }
          return color;
        case "company_name":
          this.company.forEach(s => {
            if (s.company_name == value) {
              if (s.color && s.color.replace) {
                // if (!isItem) {
                //   color = s.color.replace("#", "");
                // } else {
                color = s.color;
                // }
              } else {
                color = "black";
              }
            }
          });
          return color;
        default:
          break;
      }
      // if (field == "service_type") {
      //   return this.getServiceColor(value, true);
      // }
      // if (field == "booked") {
      //   return value == "Booked" ? "green" : "black";
      // }
      // if (field == "lead_status") {
      //   return value == "Booked" ? "green" : "black";
      // }
    },

    getServiceColor(serviceType, isItem) {
      var color = "";
      this.serviceTypes.forEach(s => {
        if (s.service_type == serviceType) {
          if (s.color && s.color.replace) {
            if (!isItem) {
              color = s.color.replace("#", "");
            } else {
              color = s.color;
            }
          } else {
            color = "";
          }
        }
      });
      if (!isItem) {
        return "color-" + color;
      } else {
        return color;
      }
    },
    getStage(d) {
      this.stages.forEach(s => {
        if (s.old_statuses) {
          if (!Array.isArray(s.old_statuses)) {
            s.old_statuses = [s.old_statuses];
          }
          s.old_statuses.forEach(st => {
            if (st.toLowerCase() == d.lead_status.toLowerCase()) {
              d.stage = s.stage;
            }
          });
        }
      });
      return d;
    },
    getLocation(rec, s, isOrig) {
      var locations = rec.address;
      var location;

      var nStops = s.shipment_stop.length;
      var stopNum = isOrig ? 1 : nStops;
      s.shipment_stop.forEach((st, i) => {
        if (parseInt(st.stop_number) == stopNum) {
          location = locations.filter(l => {
            return l.address_type == st.address_label;
          });
          if (location.length) {
            location = location[0].location;
          }
        }
      });
      if (location && location.address && location.address.geo && location.address.geo.location) {
        return location.address.geo.location.address;
      }
    },
    onDataReceived(data) {
      this.vBind = data.schema["v-bind"];
      this.data_object.schema = data.schema;
      Object.keys(data.additional_structure.international_shipment.properties).forEach(k => {
        if (data.additional_structure.international_shipment.properties[k].filter == "dayRangeFilter") {
          data.additional_structure.international_shipment.properties[k]["x-display"] = "v-date-range-picker";
        }
        data.additional_structure.international_shipment.properties[k].cols = 12;
      });
      this.data_object.schema.properties = {
        ...this.data_object.schema.properties,
        ...data.additional_structure.international_shipment.properties
      };

      this.data_object.headers = data.headers;
      var interHeaders = [];
      Object.keys(data.additional_structure.international_shipment.properties).forEach(h => {
        var f = data.additional_structure.international_shipment.properties[h];
        if (!f.hideInTable && f.filter) {
          var title = h
            .split("_")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
          var header = {
            text: title,
            value: h,
            show: false,
            hidden: true,
            groupable: false
          };
          interHeaders.push(h);
          this.data_object.headers.push(header);
        }
      });
      var tabs = this.data_object.schema["v-bind"].filterTabs;
      // tabs["v-bind"] = {
      this.data_object.initialHideHeaders = interHeaders;
      // }
      this.vBind;
      tabs.forEach(t => {
        if (t.value == "international") {
          t.options = [
            {
              showHeaders: interHeaders
            }
          ];
        } else {
          t.options = [
            {
              hideHeaders: interHeaders
            }
          ];
        }
      });

      this.serviceTypes = data.additional_model.service_type;
      this.leadStatus = data.additional_model.lead_status;
      this.company = data.additional_model.company;
      this.employeeList = data.additional_model.employee;
      if (this.company.length == 1) {
        data.schema.properties["company_name"].hideInTable = true;
      }
      this.stages = data.additional_model.stage;
      if (this.$root.customerId) {
        try {
          var myCompany = this.company.filter(c => {
            return data.model[0] && data.model[0].shipment_detail.company._id == c._id;
          });
          if (myCompany && myCompany.length) {
            this.$root.logo = myCompany[0].logo_url;
          } else {
            this.$root.logo = this.company[0].logo_url;
          }
        } catch (error) {
          //
        }
      }

      data.model.forEach(d => {
        d._id = fun.guid();
        // d = this.getStage(d);
        // if(!d.stage){

        // }
        if (
          data.additional_model.ai_chat.find(c => {
            return c.order_id == d.sid;
          })
        ) {
          d.lead_status += " (used AI)";
        }

        if (!d.sales_person) {
          if (!d.booked) {
            d.stage = "unassigned_leads";
          }
        } else {
          if (!d.stage) {
            d.stage = "assigned_leads";
          }
        }
        try {
          if (!d.move_type) {
            var serviceType = d.service_type;
            if (serviceType.toLowerCase().includes("local")) {
              d.move_type = "local";
            }
            if (serviceType.toLowerCase().includes("short")) {
              d.move_type = "short_haul";
            }
            if (serviceType.toLowerCase().includes("long")) {
              d.move_type = "interstate";
            }
            if (serviceType.toLowerCase().includes("international")) {
              d.move_type = "international";
            }
          }
        } catch (error) {
          //
        }
      });
      var classes = "";
      this.serviceTypes.forEach(s => {
        try {
          if (s.color && s.color.replace) {
            var className = "color-" + s.color.replace("#", "");
            var classCss = "border: 5px solid " + s.color + ";";

            var cl = "\n." + className + " { " + classCss + "}";
            if (classes.indexOf(cl) == -1) {
              classes += cl;
            }
          }
        } catch (error) {
          console.log(error);
        }
      });

      this.$root.dynamicClasses(classes);

      data.table = data.model;
      // delete data.model;

      return data;
    }
  },
  watch: {
    activeTab() {
      if (this.activeTab) {
        this.data_object.object_name = "v_shipments_limited_by_day";
      } else {
        this.data_object.object_name = "shipments";
        if (this.tabTitle == "All Leads") {
          this.mount();
        }
      }
    },
    plansSelected() {
      if (this.showSalesClicked) {
        var btnLabel = this.plansSelected.length ? "Assign " + this.plansSelected.length + " leads to:" : this.btnLabel;
        this.toolBarControls[0]["v-bind"]["input-value"] = btnLabel;
        this.showSalesPersonList = this.plansSelected.length;
        this.toolBarControls[1].hidden = !this.plansSelected.length;
      }
      if (this.showCompaniesClicked) {
        var btnLabelCompanies = this.plansSelected.length
          ? "Assign " + this.plansSelected.length + " leads to:"
          : this.btnLabelCompanies;
        this.toolBarControls[2]["v-bind"]["input-value"] = btnLabelCompanies;
        this.showSalesPersonList = this.plansSelected.length;
        this.toolBarControls[3].hidden = !this.plansSelected.length;
      }
    },
    salesPerson() {
      console.log(this.salesPerson);
    }
  }
};
</script>
<style scoped>
/* .v-tab {
  background-color: white;
  margin: 1px !important;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border: solid 1px;
} */
</style>
